import Table from "./table";

export const TravelsApprove = () => {

    return (
            <Table/>
    );
}